interface IValidateMobilePhoneProps {
  cellphone: string;
  incorrectCellphone: string;
  emptyCellphone: string;
}

interface IValidateMobilePhoneReturn {
  status: 'notOk' | 'vazio' | 'ok';
  message: string;
}

const DEFAULT_FROTA_PHONE = '11888888888';

const validateMobilePhone = ({
  cellphone,
  incorrectCellphone,
  emptyCellphone,
}: IValidateMobilePhoneProps): IValidateMobilePhoneReturn => {
  let value = cellphone.replace(/\D/g, '');

  if (value === DEFAULT_FROTA_PHONE)
    return {
      message: '',
      status: 'ok',
    };

  if (value === '')
    return {
      message: emptyCellphone,
      status: 'vazio',
    };

  for (let i = 0; i < 10; i++) {
    if (
      value === new Array(11).join(i.toString()) ||
      value === new Array(12).join(i.toString())
    )
      return {
        message: incorrectCellphone,
        status: 'notOk',
      };
  }

  if (!(value.length >= 10 && value.length <= 11))
    return {
      message: incorrectCellphone,
      status: 'notOk',
    };

  //Se tiver 11 caracteres, verificar se começa com 9 o celular
  if (value.length === 11 && parseInt(value.substring(2, 3)) !== 9)
    return {
      message: incorrectCellphone,
      status: 'notOk',
    };

  const codigosDDD = [
    11, 12, 13, 14, 15, 16, 17, 18, 19, 21, 22, 24, 27, 28, 31, 32, 33, 34, 35,
    37, 38, 41, 42, 43, 44, 45, 46, 47, 48, 49, 51, 53, 54, 55, 61, 62, 64, 63,
    65, 66, 67, 68, 69, 71, 73, 74, 75, 77, 79, 81, 82, 83, 84, 85, 86, 87, 88,
    89, 91, 92, 93, 94, 95, 96, 97, 98, 99,
  ];

  if (codigosDDD.indexOf(parseInt(value.substring(0, 2))) === -1)
    return {
      message: incorrectCellphone,
      status: 'notOk',
    };

  return {
    message: '',
    status: 'ok',
  };
};

export { validateMobilePhone };
